var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconArticleTimes = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("path", { d: "M18.9,8.1c0-2.2-1.7-3.9-3.9-3.9S11.1,6,11.1,8.1S12.8,12,15,12\n\tC17.1,12,18.9,10.3,18.9,8.1C18.9,8.1,18.9,8.1,18.9,8.1z M13.3,14.8c-2.4-1.5-6.3-1.9-8.3-2c-0.6,0-1.2,0.4-1.2,1c0,0,0,0,0,0.1v9\n\tc0,0.6,0.5,1.1,1.1,1.1c2.7,0.1,5.3,0.6,7.8,1.7c0.3,0.1,0.6,0,0.8-0.2c0-0.1,0.1-0.2,0.1-0.2v-10C13.6,15.1,13.5,14.9,13.3,14.8\n\tL13.3,14.8z M25,12.8c-2,0.1-5.9,0.5-8.3,2c-0.2,0.1-0.3,0.3-0.3,0.5v10c0,0.3,0.3,0.6,0.6,0.5c0.1,0,0.2,0,0.3-0.1\n\tc2.5-1,5.1-1.6,7.8-1.7c0.6,0,1.1-0.5,1.1-1.1v-9C26.2,13.3,25.7,12.8,25,12.8C25,12.8,25,12.8,25,12.8L25,12.8z" }),
            React.createElement("path", { d: "M10.7,17.5L7,20.4" }),
            React.createElement("path", { d: "M10.7,21.2L7,16.7" }))));
});
export default IconArticleTimes;
//# sourceMappingURL=IconArticleTimes.js.map